import axios from "axios";
import { ModalContext } from "app/app";
import { Fragment, useCallback, useContext, useState } from 'react';
import { Form, Formik } from 'formik';
import { useNavigate, ViewContext } from "components/lib";
import { FieldInput } from "components/fieldInput";
import styles from "./styles.module.scss";
import { useEffect } from "react";
import CurrencyInput from "react-currency-input-field";
import { Spinner } from "../../spinner/spinner";
import { validationSchema } from "./validationSchema";

// Import carrier logos
import coverWhaleLogo from "../../../assets/coverwhale_logo_white.png";
import progressiveLogo from "../../../assets/Progressive.png";
import nirvanaLogo from "../../../assets/Nirvana.png";

export function RenewalModal() {
  const context = useContext(ViewContext);
  const navigate = useNavigate();
  const { modal, setModal } = useContext(ModalContext);

  // Function to get the appropriate logo based on selected carrier
  const getCarrierLogo = (carrier) => {
    switch (carrier) {
      case "Cover Whale":
        return coverWhaleLogo;
      case "Progressive":
        return progressiveLogo;
      case "Nirvana":
        return nirvanaLogo;
      default:
        return null;
    }
  };

  const quoteType = [
    { label: "Cover Whale", value: "Cover Whale" },
    { label: "Progressive", value: "Progressive" },
    { label: "Nirvana", value: "Nirvana" },
  ]
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [agenciesOptions, setAgenciesOptions] = useState([]);
  const [companiesOptions, setCompaniesOptions] = useState([]);
  const [submissionValue, setSubmissionValue] = useState("");
  const [premiumValue, setPremiumValue] = useState("");
  const [agencyNames, setAgencyNames] = useState({});
  const [companyIds, setCompanyIds] = useState({});
  const [companyEmails, setCompanyEmails] = useState({});
  const [companyNames, setCompanyNames] = useState({});
  const [loading, setLoading] = useState(false);
  const [renewalDate, setRenewalDate] = useState("");
  const [formValues, setFormValues] = useState({
    currentCarrier: "",
    submissionNumber: "",
    agency: "",
    company: "",
    premium: "",
    renewalDate: "",
  });
  const [isFormValid, setIsFormValid] = useState(false);

  // const fetchQuoteData = async () => {
  //   try {
  //     const response = await axios.get("/api/quote/admin");
  //     const data = response.data.data.data;
  //
  //     const sortedAgencies = data.accounts
  //       .map((agency) => ({
  //         label: agency.name.trim(),
  //         value: agency.id,
  //       }))
  //       .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
  //
  //     const sortedCompanies = data.companies
  //       .map((company) => ({
  //         label: company.name.trim(),
  //         value: company.name,
  //       }))
  //       .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));
  //
  //     setAgenciesOptions(sortedAgencies);
  //     setCompaniesOptions(sortedCompanies);
  //
  //     const emails = data.companies.reduce((acc, company) => {
  //       acc[company.name] = company.email;
  //       return acc;
  //     }, {});
  //     const ids = data.companies.reduce((acc, company) => {
  //       acc[company.name] = company.id;
  //       return acc;
  //     }, {});
  //     const names = data.companies.reduce((acc, company) => {
  //       acc[company.name] = company.name;
  //       return acc;
  //     }, {});
  //     const agencyNames = data.accounts.reduce((acc, agency) => {
  //       acc[agency.id] = agency.name;
  //       return acc;
  //     }, {});
  //     setCompanyEmails(emails);
  //     setCompanyIds(ids);
  //     setCompanyNames(names);
  //     setAgencyNames(agencyNames);
  //   } catch (error) {
  //     console.error(error);
  //     context.notification.show(
  //       "Failed to load quote",
  //       "error",
  //       true,
  //       "toast",
  //       "x-circle"
  //     );
  //   }
  // }

  const fetchAllCompanies = async () => {
    try {
      const response = await axios.get("/api/company/all");
      console.log("All Companies:", response.data.data);

      const companies = response.data.data;
      const sortedCompanies = companies
        .map((company) => ({
          label: company.name.trim(),
          value: company.name,
        }))
        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));



      setCompaniesOptions(sortedCompanies);

      const emails = companies.reduce((acc, company) => {
        acc[company.name] = company.email;
        return acc;
      }, {});

      const ids = companies.reduce((acc, company) => {
        acc[company.name] = company.id;
        return acc;
      }, {});

      const names = companies.reduce((acc, company) => {
        acc[company.name] = company.name;
        return acc;
      }, {});

      setCompanyEmails(emails);
      setCompanyIds(ids);
      setCompanyNames(names);
      return companies; // Return the companies data for potential auto-selection
    } catch (error) {
      console.error("Error fetching all companies:", error);
      context.notification.show(
        "Failed to load companies",
        "error",
        true,
        "toast",
        "x-circle"
      );
      throw error;
    }
  };

  const fetchAllAccounts = async () => {
    try {
      const response = await axios.get("/api/account/all/minimal");
      console.log("All Accounts:", response.data.data);

      const agencies = response.data.data;
      const sortedAgencies = agencies
        .map((agency) => ({
          label: agency.name.trim(),
          value: agency.id,
        }))
        .sort((a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase()));



      setAgenciesOptions(sortedAgencies);
      return agencies; // Return the agencies data for potential auto-selection
    } catch (error) {
      console.error("Error fetching all accounts:", error);
      context.notification.show(
        "Failed to load agencies",
        "error",
        true,
        "toast",
        "x-circle"
      );
      throw error;
    }
  };

  useEffect(() => {
    fetchAllCompanies();
    fetchAllAccounts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Reset form when modal opens to clear any previous selections
  useEffect(() => {
    if (modal.name === "renewal_modal") {
      resetForm();
    }
  }, [modal.name]);

  const handleBlurSubmission = async () => {
    if (submissionValue && selectedCarrier === "Cover Whale") {
      try {
        const res = await axios.get(`/api/quote/info/${submissionValue}`);
        const validQuote = res.data.data;

        if (validQuote) {
          setFormValues({
            currentCarrier: formValues.currentCarrier,
            submissionNumber: submissionValue,
            premium: validQuote.coverages.al.premium,
            renewalDate: validQuote.coverages.al.policy_expiration_date
          });

          setPremiumValue(validQuote.coverages.al.premium)
          setRenewalDate(validQuote.coverages.al.policy_expiration_date)

          document.getElementById("premium").value = validQuote.coverages.al.premium;
          document.getElementById("renewal_date").value = validQuote.coverages.al.policy_expiration_date;

          handleFormValidity("premium", validQuote.coverages.al.premium);
          handleFormValidity("renewalDate", validQuote.coverages.al.policy_expiration_date);
        } else {
          console.error("No valid quote found.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const resetForm = () => {
    setFormValues({
      currentCarrier: "",
      submissionNumber: "",
      agency: "",
      company: "",
      premium: "",
      renewalDate: "",
    });
    setIsFormValid(false);
    // Reset all individual form states
    setSelectedCarrier(null);
    setSubmissionValue("");
    setPremiumValue("");
    setRenewalDate("");
    setCompanyInfo({
      companyId: "",
      companyName: "",
      companyEmail: "",
    });
    setAgencyInfo({
      agencyId: "",
      agencyName: "",
    });
    setSelectedAgency(null);
    setSelectedCompany(null);
    setCompanyNameText("");
    setLoading(false);
    
    // Clear DOM input values that might be set directly
    const premiumInput = document.getElementById("premium");
    const renewalDateInput = document.getElementById("renewal_date");
    const carrierSelect = document.getElementById("carrier_filter");
    const submissionInput = document.getElementById("quote");
    const companyTextInput = document.getElementById("company_text");
    
    if (premiumInput) premiumInput.value = "";
    if (renewalDateInput) renewalDateInput.value = "";
    if (carrierSelect) carrierSelect.value = "";
    if (submissionInput) submissionInput.value = "";
    if (companyTextInput) companyTextInput.value = "";
    
    // Note: ReactSelect components will be cleared by state reset
  };

  const [companyInfo, setCompanyInfo] = useState({
    companyId: "",
    companyName: "",
    companyEmail: "",
  });

  const [agencyInfo, setAgencyInfo] = useState({
    agencyId: "",
    agencyName: "",
  });
  
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyNameText, setCompanyNameText] = useState(""); // For text input when not Cover Whale

  const handleFormValidity = useCallback((field, value) => {
    setFormValues(prevValues => {
      const updatedFormState = { ...prevValues, [field]: value };
      return updatedFormState;
    });
  }, []);

  useEffect(() => {
    const requiredFields = [
      "currentCarrier",
      "submissionNumber",
      "agency",
      "company",
      "premium",
      "renewalDate",
    ];

    const allFieldsFilled = requiredFields.every(
      (key) => formValues[key] && formValues[key].toString().trim() !== ""
    );
    setIsFormValid(allFieldsFilled);
  }, [formValues]);

  const handleCarrierChange = (carrier) => {
    setSelectedCarrier(carrier);
    
    // Reset company selection when carrier changes
    setSelectedCompany(null);
    setCompanyNameText("");
    setCompanyInfo({
      companyId: "",
      companyName: "",
      companyEmail: "",
    });
    
    // Clear the company field from form validation
    handleFormValidity("company", "");
  };

  const handleModalClose = () => {
    resetForm();
    setModal("");
  };

  const handleCompanyChange = (selectedOption) => {
    const companyName = selectedOption.value;
    setSelectedCompany(selectedOption);
    setCompanyInfo({
      companyId: companyIds[companyName],
      companyName: companyNames[companyName],
      companyEmail: companyEmails[companyName],
    });
    
    handleFormValidity("company", companyName);
  };

  const handleAgencyChange = (selectedOption) => {
    const selectedAgencyId = selectedOption.value;
    const selectedAgencyName = selectedOption.label;

    setSelectedAgency(selectedOption);
    setAgencyInfo({
      agencyId: selectedAgencyId,
      agencyName: selectedAgencyName,
    });
    
    handleFormValidity("agency", selectedAgencyId);
  };

  const createRenewal = async () => {
    const data = await axios.get(`/api/account/${agencyInfo.agencyId}`)
    const agentEmail = data.data.data.owner_email;

    let renewalData = {
      status: "Active",
      carrier: formValues.currentCarrier,
      userId: companyInfo.companyId,
      agencyId: agencyInfo.agencyId,
      assignedUserEmail: companyInfo.companyEmail,
      assignedAgentEmail: agentEmail,
      submissionNumber: submissionValue,
      companyName: companyInfo.companyName,
      renewalPremium: premiumValue,
      renewalDate: renewalDate,
      agencyName: agencyInfo.agencyName,
    };

    try {
      setLoading(true);

      const response = await axios.post("/api/renewals", renewalData);
      if (response.status === 201) {
        const renewalId = response.data.data.id;
        handleModalClose();
        navigate(`/admin/renewal/${renewalId}`);
      }
    } catch (error) {
      setLoading(false)
      console.error('Error creating renewal:', error);
    }
    setLoading(false)
  };

  const handleSubmit = () => {
    return createRenewal();
  }

  return (
    <Fragment>
      {modal.name === "renewal_modal" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.insideWrapper}>
              {/* Display carrier logo if selected */}
              {selectedCarrier && getCarrierLogo(selectedCarrier) && (
                <div style={{ textAlign: "center", marginBottom: 20 }}>
                  <img
                    src={getCarrierLogo(selectedCarrier)}
                    alt={`${selectedCarrier} Logo`}
                    style={{
                      maxHeight: 60,
                      maxWidth: 200,
                      objectFit: "contain",
                      filter: "invert(1)"
                    }}
                  />
                </div>
              )}
              <div
                style={{
                  fontStyle: "normal",
                  fontWeight: 500,
                  fontSize: 24,
                  marginBottom: 10,
                  color: "black",
                }}
              >
                Create Renewal
              </div>
              <Formik
                initialValues={{
                  submissionNumber: "",
                  currentCarrier: "",
                  agency: "",
                  company: "",
                  premium: "",
                  renewalDate: "",
                }}
                validationSchema={validationSchema}
              >
                <>
                  <Form className={styles.form}>
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "center",
                        alignItems: "center",
                        color: "black",
                        marginTop: 20,
                        marginBottom: 20,
                      }}
                    >
                      <>
                        <div style={{ marginTop: 5 }}>
                          <label htmlFor="carrier_filter">Current Carrier</label>
                          <select
                            id="carrier_filter"
                            onChange={(e) => {
                              handleCarrierChange(e.target.value);
                              handleFormValidity("currentCarrier", e.target.value)
                            }}
                            defaultValue=""
                            style={{
                              width: "100%",
                              padding: "10px",
                              fontSize: "16px",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                            }}
                          >
                            <option value="" disabled>
                              Select a carrier
                            </option>
                            {quoteType.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                            ))}
                          </select>
                        </div>
                        <div style={{ marginTop: 5 }}>
                          <label htmlFor="quote">
                            {selectedCarrier === "Cover Whale" ? "Submission Number" : "Policy Number"}
                          </label>
                          <input
                            id="quote"
                            type="text"
                            name="submissionNumber"
                            placeholder={
                              selectedCarrier === "Cover Whale" 
                                ? "Enter submission number..." 
                                : "Enter policy number..."
                            }
                            onBlur={selectedCarrier === "Cover Whale" ? handleBlurSubmission : undefined}
                            onChange={(e) => {
                              handleFormValidity("submissionNumber", e.target.value);
                              setSubmissionValue(e.target.value);
                            }}
                            value={submissionValue}
                            disabled={!selectedCarrier}
                            style={{
                              width: "100%",
                              padding: "10px",
                              fontSize: "16px",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                            }}
                          />
                        </div>
                        <div style={{ marginTop: 5 }}>
                          <label htmlFor="agency_filter">Select Agency</label>
                          <FieldInput
                            id="agency_filter"
                            name="agency"
                            type="search_select"
                            options={agenciesOptions}
                            value={selectedAgency}
                            handleChange={handleAgencyChange}
                            disabled={!selectedCarrier}
                            placeholder="Search agencies..."
                            styles={{
                              container: (baseStyles) => ({
                                ...baseStyles,
                                width: "100%",
                                marginTop: "5px",
                              }),
                              control: (baseStyles) => ({
                                ...baseStyles,
                                width: "100%",
                                padding: "2px",
                                fontSize: "16px",
                                borderRadius: "8px",
                                border: "1px solid #ccc",
                              }),
                            }}
                          />
                        </div>
                        <div style={{ marginTop: 5 }}>
                          {selectedCarrier === "Cover Whale" ? (
                            // Dropdown for Cover Whale
                            <>
                              <label htmlFor="company_filter">Name of Insured</label>
                              <FieldInput
                                id="company_filter"
                                name="company"
                                type="search_select"
                                options={companiesOptions}
                                value={selectedCompany}
                                handleChange={handleCompanyChange}
                                disabled={!selectedCarrier}
                                placeholder="Search companies..."
                                styles={{
                                  container: (baseStyles) => ({
                                    ...baseStyles,
                                    width: "100%",
                                    marginTop: "5px",
                                  }),
                                  control: (baseStyles) => ({
                                    ...baseStyles,
                                    width: "100%",
                                    padding: "2px",
                                    fontSize: "16px",
                                    borderRadius: "8px",
                                    border: "1px solid #ccc",
                                  }),
                                }}
                              />
                            </>
                          ) : (
                            // Text input for Progressive/Nirvana
                            <>
                              <label htmlFor="company_text">Name of Insured</label>
                              <input
                                id="company_text"
                                type="text"
                                name="companyName"
                                placeholder="Enter company name..."
                                onChange={(e) => {
                                  setCompanyNameText(e.target.value);
                                  handleFormValidity("company", e.target.value);
                                  // Set basic company info for text input
                                  setCompanyInfo({
                                    companyId: "",
                                    companyName: e.target.value,
                                    companyEmail: "",
                                  });
                                }}
                                value={companyNameText}
                                disabled={!selectedCarrier}
                                style={{
                                  width: "100%",
                                  padding: "10px",
                                  fontSize: "16px",
                                  borderRadius: "8px",
                                  border: "1px solid #ccc",
                                  marginTop: "5px",
                                }}
                              />
                            </>
                          )}
                        </div>
                        <div style={{ marginTop: 5 }}>
                          <label htmlFor="premium">Renewal Premium</label>
                          <CurrencyInput
                            intlConfig={{ locale: 'en-US', currency: 'USD' }}
                            id="premium"
                            name="premium"
                            defaultValue={1000}
                            decimalsLimit={2}
                            placeholder="Enter premium value..."
                            onValueChange={(e) => {
                              setPremiumValue(e);
                              handleFormValidity("premium", e);
                            }}
                            value={premiumValue}
                            disabled={!selectedCarrier}
                            style={{
                              width: "100%",
                              padding: "10px",
                              fontSize: "16px",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                            }}
                          />
                        </div>
                        <div style={{ marginTop: 5 }}>
                          <label htmlFor="renewal_date">Renewal Date</label>
                          <input
                            id="renewal_date"
                            type="date"
                            name="renewalDate"
                            placeholder="Enter renewal date..."
                            onChange={(e) => {
                              setRenewalDate(e.target.value);
                              handleFormValidity("renewalDate", e.target.value);
                            }}
                            value={renewalDate}
                            disabled={!selectedCarrier}
                            style={{
                              width: "100%",
                              padding: "10px",
                              fontSize: "16px",
                              borderRadius: "8px",
                              border: "1px solid #ccc",
                            }}
                          />
                        </div>
                      </>
                    </div>
                  </Form>
                  <div
                    className={styles.footer}
                    style={{
                      justifyContent: "flex-end",
                    }}
                  >
                    <div className={styles.buttons}>
                      <button className={styles.cancel} onClick={handleModalClose}>
                        Cancel
                      </button>

                      <button
                        className={styles.save}
                        type="button"
                        onClick={handleSubmit}
                        disabled={!isFormValid}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </>
              </Formik>
            </div>
          </div>
        </div>
      )}
      <Spinner loading={loading} />
    </Fragment>
  )
}
